if (window.customElements && !customElements.get('aur-scroll-row')) {
  customElements.define('aur-scroll-row', class extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.track = this.querySelector('[data-scroll-track]');
      if (!this.track) return;
      this.initialized = true;
      this.onClick = (event) => {
        if (!(event.target instanceof Element)) return;
        const button = event.target.closest('button');
        if (!button || !this.contains(button) || button.disabled) return;
        if (button.hasAttribute('data-scroll-index')) {
          const slide = this.track.querySelectorAll('[data-scroll-slide]')[Number(button.dataset.scrollIndex)];
          if (slide) this.moveTo(this.track.scrollLeft + slide.getBoundingClientRect().left - this.track.getBoundingClientRect().left);
        } else if (button.dataset.scroll) {
          const card = this.track.firstElementChild;
          const gap = parseFloat(getComputedStyle(this.track).columnGap) || 0;
          const distance = card ? card.getBoundingClientRect().width + gap : this.track.clientWidth;
          this.moveTo(this.track.scrollLeft + distance * (button.dataset.scroll === 'next' ? 1 : -1));
        }
      };
      this.onScroll = () => this.update();
      this.onKey = (event) => {
        if (event.target !== this.track || !['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;
        event.preventDefault();
        const max = this.track.scrollWidth - this.track.clientWidth;
        if (event.key === 'Home') this.moveTo(0);
        else if (event.key === 'End') this.moveTo(max);
        else this.moveTo(this.track.scrollLeft + this.track.clientWidth * (event.key === 'ArrowRight' ? 1 : -1));
      };
      this.addEventListener('click', this.onClick);
      this.track.addEventListener('scroll', this.onScroll, {passive: true});
      this.track.addEventListener('keydown', this.onKey);
      if (typeof ResizeObserver === 'function') {
        this.observer = new ResizeObserver(this.onScroll);
        this.observer.observe(this.track);
      } else window.addEventListener('resize', this.onScroll);
      this.update();
    }
    moveTo(left) {
      const position = Math.max(0, Math.min(left, this.track.scrollWidth - this.track.clientWidth));
      const reduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      if (typeof this.track.scrollTo === 'function') {
        try { this.track.scrollTo({left: position, behavior: reduced ? 'auto' : 'smooth'}); }
        catch { this.track.scrollLeft = position; }
      } else this.track.scrollLeft = position;
      this.update();
    }
    disconnectedCallback() {
      if (!this.initialized) return;
      this.removeEventListener('click', this.onClick);
      this.track.removeEventListener('scroll', this.onScroll);
      this.track.removeEventListener('keydown', this.onKey);
      if (this.observer) this.observer.disconnect();
      else window.removeEventListener('resize', this.onScroll);
      this.initialized = false;
    }
    update() {
      const max = this.track.scrollWidth - this.track.clientWidth;
      const previous = this.querySelector('[data-scroll="previous"]');
      const next = this.querySelector('[data-scroll="next"]');
      if (previous) previous.disabled = this.track.scrollLeft < 2;
      if (next) next.disabled = this.track.scrollLeft >= max - 2;
      const slides = Array.from(this.track.querySelectorAll('[data-scroll-slide]'));
      if (!slides.length) return;
      let active = 0, distance = Infinity;
      const left = this.track.getBoundingClientRect().left;
      slides.forEach((slide, index) => {
        const current = Math.abs(slide.getBoundingClientRect().left - left);
        if (current < distance) { distance = current; active = index; }
      });
      this.querySelectorAll('[data-scroll-index]').forEach((button, index) => button.setAttribute('aria-pressed', String(index === active)));
    }
  });
}

document.addEventListener('click', (event) => {
  if (!(event.target instanceof Element)) return;
  const link = event.target.closest('header-drawer a[href*="#"]');
  if (!link) return;
  const drawer = link.closest('header-drawer');
  const summary = drawer.querySelector('summary');
  if (summary && typeof drawer.closeMenuDrawer === 'function') {
    drawer.closeMenuDrawer(event, summary);
    summary.setAttribute('aria-expanded', 'false');
  }
});
